import { Component } from '@angular/core';

import { fuseAnimations } from '@fuse/animations';

///IDIOMAS
import { lang_configuracion } from '../../../idiomas/i18n/configuracion/configuracion.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector   : 'config',
    templateUrl: './config.component.html',
    styleUrls  : ['./config.component.scss'],
    animations : fuseAnimations
})
export class ConfigComponent
{
    filteredCourses: any[]= [
        {
            'id'      : '1',
            'title'   : 'Collaborators database upload',
            'slug'    : 'collaborators',
            'category': 'CGO',
            'length'  : 30,
            'icon' : 'group'
        },
        {
            'id'      : '2',
            'title'   : 'Logo upload',
            'slug'    : 'logo',
            'category': 'CGO',
            'length'  : 30,
            'icon' : 'local_see'
        },
        {
            'id'      : '3',
            'title'   : 'Tecnical requirements information',
            'slug'    : 'requirements',
            'category': 'CGO',
            'length'  : 30,
            'icon' : 'laptop_windows'
        }
    ];

    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService
    )
    {
        //this._fuseTranslationLoaderService.loadTranslations(lang_configuracion);
        lang_configuracion.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
    }
}
